import { getFolderDetail, getPageInfo } from "./api/pages";
import { joyspacePermissionType } from "./config/permissions.config";
import InitJoySpaceController from "./controllers/InitJoySpaceController";
// import InitDBService from "./controllers/InitJoySpaceController";
import JoyspaceController from "./controllers/JoyspaceController";
import { MenusType, PartialUpdateType, ActionFnEnum, FileType, ActionType } from "./types";
import { notUseJoySpaceOffline } from "./util";

function saveToDB(data: any) {
  const { path, newList = [], id, actionType = ActionType.Page, parentId = "" } = data;
  // 初始化数据库
  InitJoySpaceController.init();
  const Controller = JoyspaceController;
  let args: any = { start: 0, length: 30 };
  switch (path) {
    case MenusType.SHORTCUT:
      Controller.setShortcutsList(path, { shortcuts: newList }, args);
      break;
    case MenusType.RECENT:
      Controller.setList(path, { pages: newList }, args);
      break;
    case MenusType.SHAREBY:
      Controller.setList(path, { pages: newList }, args);
      break;
    case MenusType.SHARE:
      Controller.setSharesList(path, { shares: newList }, args);
      break;
    case MenusType.COLLECTION:
      Controller.setCollectionsList(path, { data: newList }, args, actionType);
      break;
    case MenusType.TRASHES:
      Controller.setTrashesList(path, { trashes: newList }, args);
      break;
  }
  if (path === MenusType.MYSPACE || path === MenusType.TEAMSPACE) {
    if (actionType === ActionType.Folder) {
      // args = {id};
      Controller.setFolderList("getFileList", newList, parentId);
    } else if (actionType === ActionType.Page) {
      Controller.setList("space", { pages: newList }, args, parentId);
    } else {
      const folderArr: any = newList.filter((item: any) => typeof item.page_type === "undefined");
      let pageArr = [...newList];
      if (folderArr.length > 0) {
        const idx = folderArr.length;
        pageArr.splice(0, idx);
        Controller.setFolderList("getFileList", newList, parentId);
      }
      Controller.setList("space", { pages: pageArr }, args, parentId);
    }
  }
}
const getFileInfo = (type = FileType.Page, id = "") => {
  if (!id) {
    console.error("id  can't null");
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(joyspacePermissionType.ReadNothing);
  }
  return new Promise((resolve, reject) => {
    if (!id) {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(joyspacePermissionType.ReadNothing);
    }
    const isFolder = type === FileType.Folder;
    let promise: any = isFolder ? getFolderDetail(id) : getPageInfo(id);
    promise
      .then((res: any) => {
        // console.log(res, "resres=====>");
        if (!res) {
          reject(joyspacePermissionType.ReadNothing);
          return;
        }
        if (isFolder) {
          res.title = res.name;
          res.isFolder = isFolder;
        } else {
          res.title = res.title || "无标题";
          resolve(res.page || res);
          return;
        }
        resolve(res);
      })
      .catch((err: any) => {
        console.error(err);
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(joyspacePermissionType.ReadNothing);
      });
  });
};

const UpdataService: any = {
  data: [],
  getList(sort = 0) {
    if (sort === -1) {
      return [...this.data].reverse();
    }
    return [...this.data];
  },
  setList(list: any[] = []) {
    this.data = [...list];
  },
  findItem(id: string) {
    return this.data.find((item: any) => item.id === id) || null;
  },
  add(newItem: any) {
    if (newItem) {
      this.data.unshift(newItem);
      return true;
    }
    return false;
  },
  addFileAll(newItem: any) {
    if (!newItem) {
      console.error("newItem not null");
      return false;
    }
    const isFolder = typeof newItem.page_type === "undefined";
    if (!this.data.length || isFolder) {
      this.data.unshift(newItem);
      return true;
    }
    let idx = this.data.findIndex((item: any) => item.page_type);
    if (idx !== -1) {
      this.data.splice(idx, 0, newItem);
    } else {
      this.data.push(newItem);
    }
    return true;
  },
  batchAdd(newList: any[] = []) {
    if (!newList || !Array.isArray(newList)) {
      console.error("newList not null or newList not a Array");
      return false;
    }
    // const isFolder = typeof newItem.page_type === "undefined";
    if (!this.data.length) {
      this.data = newList;
      return true;
    }
    let idx = this.data.findIndex((item: any) => item.page_type);
    if (idx !== -1) {
      this.data.splice(idx, 0, ...(newList as any));
    } else {
      this.data = [].concat(newList as any, this.data);
    }
    return true;
  },
  updata(newId = "", newItem: any) {
    if (newItem && newId) {
      const idx = this.data.findIndex((item: any) => item.id === newId);
      idx !== -1 && this.data.splice(idx, 1, newItem);
      return idx !== -1;
    }
    return false;
  },
  remove(id = "") {
    if (!id) {
      return false;
    }
    const idx = this.data.findIndex((item: any) => item.id === id);
    idx !== -1 && this.data.splice(idx, 1);
    return idx !== -1;
  },
  batchRemove(ids = []) {
    if (!Array.isArray(ids)) {
      console.error("ids not a Array");
      return false;
    } else if (!ids.length) {
      console.error("ids not null");
      return false;
    }
    for (let id of ids) {
      const idx = this.data.findIndex((item: any) => item.id === id);
      if (idx !== -1) {
        this.data.splice(idx, 1);
      }
    }
    return true;
  },
  getAction(type: ActionFnEnum, path: MenusType, newItem: any) {
    let key: any = type;
    if (
      (path === MenusType.MYSPACE && type === ActionFnEnum.SHARE && !("page_type" in newItem)) ||
      (type === ActionFnEnum.ADDMEMBERS && !newItem)
    ) {
      key = ActionFnEnum.REMOVE;
    } else if (type === ActionFnEnum.SHARE) {
      key = "updata";
    }
    return key;
  },
  changeData(data: PartialUpdateType) {
    const { type, id, list, path, callback } = data;
    if (list) {
      this.setList(list);
    }
    // eslint-disable-next-line no-debugger
    // debugger;
    // 我的文件&&分享 || 删除
    let key = this.getAction(type, path, data.newItem);
    if (!key) {
      console.error("key not null");
      return;
    }
    if (type === ActionFnEnum.ADDFILEALL || type === ActionFnEnum.ADD) {
      this[key](data.newItem);
    } else if (type === ActionFnEnum.BATCHADD) {
      this[key](data.newList || []);
    } else {
      this[key](id, data.newItem);
    }
    const newList = this.getList();
    // 触发离线
    !notUseJoySpaceOffline() && saveToDB({ ...data, newList });
    // eslint-disable-next-line no-debugger
    // debugger;
    // 更新视图
    callback?.(key, newList);
  },
  upData({
    key,
    setList,
    setTotal,
    setLoadMore,
    total,
    newList,
    reIds = [],
    start = 0,
    callback
  }: any) {
    let pageIndex = 0;
    // eslint-disable-next-line no-debugger
    // debugger;
    if (key === "remove" && setTotal) {
      pageIndex = start - 1;
      let tmpTotal = total - 1;
      let tmpLoadMore = newList.length < tmpTotal;
      setTotal(tmpTotal);
      setLoadMore(tmpLoadMore);
    } else if (
      (key === ActionFnEnum.ADD || key === "addFile" || key === ActionFnEnum.ADDFILEALL) &&
      setTotal
    ) {
      pageIndex = newList.length;
      let tmpTotal = total + 1;
      let tmpLoadMore = pageIndex < tmpTotal;
      setTotal(tmpTotal);
      setLoadMore(tmpLoadMore);
    }
    if (key === "batchRemove" && setTotal) {
      pageIndex = start - reIds.length;
      let tmpTotal = total - reIds.length;
      let tmpLoadMore = newList.length < tmpTotal;
      setTotal(tmpTotal);
      setLoadMore(tmpLoadMore);
    } else if (key === "batchAdd" && setTotal) {
      pageIndex = start + reIds.length;
      let tmpTotal = total + reIds.length;
      let tmpLoadMore = newList.length < tmpTotal;
      setTotal(tmpTotal);
      setLoadMore(tmpLoadMore);
    }
    setList?.(newList);
    callback?.(pageIndex);
  }
};

export default UpdataService;
export { getFileInfo };
